<template>
  <div class="administrator">
    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          管理员名称：
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content">
          <el-input v-model="input1" size="small"></el-input>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          管理员头像：
        </div>
      </el-col>
      <el-col :span="12">
        <template v-for="(item, index) in priceArr">
          <div class="grid-content" :key="index">
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </template>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          管理员电话：
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content">
          <el-input v-model="input1" size="small"></el-input>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="issue">
      <el-col :span="5" :offset="2">
        <div class="grid-content">
          <el-button size="small" type="primary" @click="issue">提交</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "administrator", // 管理员
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      priceArr: [
        {
          days: "",
          price: ""
        }
      ],
      input1: "",
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      radio: "1",
      imageUrl: "", //图片地址
      input: "",
      dataArray: "",
      loading: false, //页面loading
      value: "",
      multipleSelection: []
    };
  },
  mounted() {},
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    issue() {
      this.$router.push({
        path: "/apply/forum/18/lanternSlide"
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.administrator {
  padding: 10px 25px;
  .grid-content {
    min-width: 80px;
    min-height: 32px;
    line-height: 32px;
  }
  .setLine {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
  }
  .hint {
    padding: 10px 0;
    color: #909399;
  }
  .align_right {
    text-align: right;
    font-size: 14px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .issue {
    padding: 10px 0 30px;
  }
}
</style>

<style lang="scss">
.administrator {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
}

</style>
